// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as dashboardLayoutRouteImport } from './routes/(dashboard)/layout'
import { Route as authLayoutRouteImport } from './routes/(auth)/layout'
import { Route as dashboardIndexRouteImport } from './routes/(dashboard)/index'
import { Route as authSigninRouteImport } from './routes/(auth)/signin'
import { Route as dashboardUsersIndexRouteImport } from './routes/(dashboard)/users/index'
import { Route as dashboardSnippetsIndexRouteImport } from './routes/(dashboard)/snippets/index'
import { Route as dashboardServicesIndexRouteImport } from './routes/(dashboard)/services/index'
import { Route as dashboardProjectsIndexRouteImport } from './routes/(dashboard)/projects/index'
import { Route as dashboardExperiencesIndexRouteImport } from './routes/(dashboard)/experiences/index'
import { Route as dashboardBlogIndexRouteImport } from './routes/(dashboard)/blog/index'
import { Route as dashboardSnippetsCreateRouteImport } from './routes/(dashboard)/snippets/create'
import { Route as dashboardServicesCreateRouteImport } from './routes/(dashboard)/services/create'
import { Route as dashboardProjectsCreateRouteImport } from './routes/(dashboard)/projects/create'
import { Route as dashboardExperiencesCreateRouteImport } from './routes/(dashboard)/experiences/create'
import { Route as dashboardBlogCreateRouteImport } from './routes/(dashboard)/blog/create'
import { Route as dashboardSnippetsSnippetIdEditRouteImport } from './routes/(dashboard)/snippets/$snippetId.edit'
import { Route as dashboardServicesServiceIdEditRouteImport } from './routes/(dashboard)/services/$serviceId.edit'
import { Route as dashboardProjectsProjectIdEditRouteImport } from './routes/(dashboard)/projects/$projectId.edit'
import { Route as dashboardExperiencesExperienceIdEditRouteImport } from './routes/(dashboard)/experiences/$experienceId.edit'
import { Route as dashboardBlogArticleIdEditRouteImport } from './routes/(dashboard)/blog/$articleId.edit'

const dashboardLayoutRoute = dashboardLayoutRouteImport.update({
            id: '/(dashboard)',getParentRoute: () => rootRouteImport
          })
const authLayoutRoute = authLayoutRouteImport.update({
            id: '/(auth)',getParentRoute: () => rootRouteImport
          })
const dashboardIndexRoute = dashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => dashboardLayoutRoute
          })
const authSigninRoute = authSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => authLayoutRoute
          })
const dashboardUsersIndexRoute = dashboardUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardSnippetsIndexRoute = dashboardSnippetsIndexRouteImport.update({
            id: '/snippets/',path: '/snippets/',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardServicesIndexRoute = dashboardServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardProjectsIndexRoute = dashboardProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardExperiencesIndexRoute = dashboardExperiencesIndexRouteImport.update({
            id: '/experiences/',path: '/experiences/',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardBlogIndexRoute = dashboardBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardSnippetsCreateRoute = dashboardSnippetsCreateRouteImport.update({
            id: '/snippets/create',path: '/snippets/create',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardServicesCreateRoute = dashboardServicesCreateRouteImport.update({
            id: '/services/create',path: '/services/create',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardProjectsCreateRoute = dashboardProjectsCreateRouteImport.update({
            id: '/projects/create',path: '/projects/create',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardExperiencesCreateRoute = dashboardExperiencesCreateRouteImport.update({
            id: '/experiences/create',path: '/experiences/create',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardBlogCreateRoute = dashboardBlogCreateRouteImport.update({
            id: '/blog/create',path: '/blog/create',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardSnippetsSnippetIdEditRoute = dashboardSnippetsSnippetIdEditRouteImport.update({
            id: '/snippets/$snippetId/edit',path: '/snippets/$snippetId/edit',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardServicesServiceIdEditRoute = dashboardServicesServiceIdEditRouteImport.update({
            id: '/services/$serviceId/edit',path: '/services/$serviceId/edit',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardProjectsProjectIdEditRoute = dashboardProjectsProjectIdEditRouteImport.update({
            id: '/projects/$projectId/edit',path: '/projects/$projectId/edit',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardExperiencesExperienceIdEditRoute = dashboardExperiencesExperienceIdEditRouteImport.update({
            id: '/experiences/$experienceId/edit',path: '/experiences/$experienceId/edit',getParentRoute: () => dashboardLayoutRoute
          })
const dashboardBlogArticleIdEditRoute = dashboardBlogArticleIdEditRouteImport.update({
            id: '/blog/$articleId/edit',path: '/blog/$articleId/edit',getParentRoute: () => dashboardLayoutRoute
          })





const authLayoutRouteChildren = {
  authSigninRoute: authSigninRoute
}

const authLayoutRouteWithChildren = authLayoutRoute._addFileChildren(authLayoutRouteChildren)




const dashboardLayoutRouteChildren = {
  dashboardIndexRoute: dashboardIndexRoute,dashboardBlogCreateRoute: dashboardBlogCreateRoute,dashboardExperiencesCreateRoute: dashboardExperiencesCreateRoute,dashboardProjectsCreateRoute: dashboardProjectsCreateRoute,dashboardServicesCreateRoute: dashboardServicesCreateRoute,dashboardSnippetsCreateRoute: dashboardSnippetsCreateRoute,dashboardBlogIndexRoute: dashboardBlogIndexRoute,dashboardExperiencesIndexRoute: dashboardExperiencesIndexRoute,dashboardProjectsIndexRoute: dashboardProjectsIndexRoute,dashboardServicesIndexRoute: dashboardServicesIndexRoute,dashboardSnippetsIndexRoute: dashboardSnippetsIndexRoute,dashboardUsersIndexRoute: dashboardUsersIndexRoute,dashboardBlogArticleIdEditRoute: dashboardBlogArticleIdEditRoute,dashboardExperiencesExperienceIdEditRoute: dashboardExperiencesExperienceIdEditRoute,dashboardProjectsProjectIdEditRoute: dashboardProjectsProjectIdEditRoute,dashboardServicesServiceIdEditRoute: dashboardServicesServiceIdEditRoute,dashboardSnippetsSnippetIdEditRoute: dashboardSnippetsSnippetIdEditRoute
}

const dashboardLayoutRouteWithChildren = dashboardLayoutRoute._addFileChildren(dashboardLayoutRouteChildren)

const rootRouteChildren = {
  authLayoutRoute: authLayoutRouteWithChildren,dashboardLayoutRoute: dashboardLayoutRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)